


















































































































































































































































































































































































































































































































































































































































































































































































































































































































































































import { Component, Vue } from "vue-property-decorator";
import HomeFooter from "@/components/footer.vue";
import HomeHeader from "@/components/header.vue";

@Component({ components: { HomeFooter, HomeHeader } })
export default class Legal extends Vue {}
